import { render } from "./TestCelery.vue?vue&type=template&id=223c6e2c"
import script from "./TestCelery.vue?vue&type=script&lang=js"
export * from "./TestCelery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__